import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout/main'
import home from '@/views/home'
import login from '@/views/common/login'
import register from '@/views/common/register'
import retrieve from '@/views/common/retrieve'
import personal from '@/views/common/personal'
import about from '@/views/about'
import dynamics from '@/views/dynamics'
import services from '@/views/services'
import interaction from '@/views/interaction'
import dynamicsInfo from '@/views/dynamics-info'
import consulting from '@/views/consulting'
import info from '@/views/info'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/login',
      component: login,
      name: 'login',
      meta: {
        title: '登录'
      }
    },
    {
      path: '/register',
      component: register,
      name: 'register',
      meta: {
        title: '注册'
      }
    },
    {
      path: '/retrieve',
      component: retrieve,
      name: 'retrieve',
      meta: {
        title: '密码找回'
      }
    },
    {
      path: '/',
      name: 'layout',
      component: layout,
      meta: {
        title: '首页'
      },
      redirect: {
        name: 'home'
      },
      children: [
        {
          path: '/personal',
          component: personal,
          name: 'personal',
          meta: {
            title: '个人中心'
          }
        },
        {
          path: '/home',
          name: 'home',
          component: home,
          meta: {
            title: '首页',
            menuId: 1197050446872576,
            enMenuId: 1316260344299520
          }
        },
        {
          path: '/about',
          name: 'about',
          component: about,
          meta: {
            title: '关于我们',
            menuId: 1197051654176768,
            enMenuId: 1316262309330944
          }
        },
        {
          path: '/dynamics',
          name: 'dynamics',
          component: dynamics,
          meta: {
            title: '联盟动态',
            menuId: 1197052764684288,
            enMenuId: 1316263590690816
          }
        },
        {
          path: '/dynamicsInfo',
          name: 'dynamicsInfo',
          component: dynamicsInfo,
          meta: {
            title: '联盟动态详情',
            menuId: 1197052764684288,
            enMenuId: 1316263590690816
          }
        },
        {
          path: '/services',
          name: 'services',
          component: services,
          meta: {
            title: '综合服务',
            menuId: 1197053684285440,
            enMenuId: 1316264840462336
          }
        },
        {
          path: '/interaction',
          name: 'interaction',
          component: interaction,
          meta: {
            title: '互动交流',
            menuId: 1197054828216320,
            enMenuId: 1316265886154752

          }
        },
        {
          path: '/consulting',
          name: 'consulting',
          component: consulting,
          meta: {
            title: '联盟咨询',
            menuId: 1197054828216320,
            enMenuId: 1316265886154752

          }
        },
        {
          path: '/info',
          name: 'info',
          component: info,
          meta: {
            title: '文章详情'
          }
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js